import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchSchoolLevelThunk: any = createAsyncThunk<IBindBaseEntity[]>(
  `${prefix} schoolLevel`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getSchoolLevels();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch school levels. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
